import GeneralHelper from '../../00_utilities/helpers/GeneralHelper';
import AccessibilityHelper from '../../00_utilities/helpers/AccessibilityHelper';
import ElementInViewHelper from '../../00_utilities/helpers/ElementInViewHelper';

class Counter {
    constructor(elem) {
        this.elem = elem;
        this.boundWindowScrollListener = this.windowScrollListener.bind(this);
        this.throttledWindowScrollListener = GeneralHelper.throttle(this.boundWindowScrollListener, 200);
    }

    init() {
        const prefersReducedMotion = AccessibilityHelper.prefersReducedMotion();
        if (!prefersReducedMotion) {
            this.initializeCounter();
        }
    }

    initializeCounter() {
        if (ElementInViewHelper.isScrolledIntoView(this.elem)) {
            this.initializeCounterAnimation();

            return;
        }

        window.addEventListener('scroll', this.throttledWindowScrollListener);
    }

    windowScrollListener() {
        if (ElementInViewHelper.isScrolledIntoView(this.elem)) {
            window.removeEventListener('scroll', this.throttledWindowScrollListener);
            this.initializeCounterAnimation();
        }
    }

    initializeCounterAnimation() {
        const counterElements = this.elem.querySelectorAll('.counter__number');

        for (const element of counterElements) {
            // const countTo = parseInt(element.innerHTML, 10);
            const initialString = element.innerHTML;
            const englishString = initialString.replace(',', '.');
            const numberDecimal = englishString.split('.')[1] ? englishString.split('.')[1].length : 0;
            const countTo = Number(englishString).toFixed(numberDecimal);

            if (!Number.isNaN(Number(englishString))) {
                this.countUp(element, countTo, numberDecimal);
            }
        }
    }

    countUp(element, countTo, numberDecimal) {
        const pageLanguage = document.documentElement.lang;
        const animationDuration = 3000; // ms
        const frameDuration = 1000 / 60;
        const totalFrames = Math.round(animationDuration / frameDuration);
        // easing functions https://gist.github.com/gre/1650294#file-easing-js
        const easeInOutQuart = (t) => {
            if (t < 0.5) {
                return 8 * t * t * t * t;
            }
            return 1 - 8 * --t * t * t * t; // eslint-disable-line no-plusplus
        };
        let frame = 0;

        const counter = setInterval(() => {
            frame += 1;

            const progress = easeInOutQuart(frame / totalFrames);
            const currentCount = (countTo * progress);

            const localizedCurrentCount = new Intl.NumberFormat(pageLanguage, {
                minimumFractionDigits: numberDecimal,
                maximumFractionDigits: numberDecimal,
                useGrouping: false,
            }).format(currentCount);

            if (parseInt(element.innerHTML, 10) !== currentCount) {
                element.innerHTML = localizedCurrentCount.toString();
            }

            if (frame === totalFrames) {
                clearInterval(counter);
            }
        }, frameDuration);
    }
}

export default Counter;
